import { createAsyncThunk } from '@reduxjs/toolkit';

import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import { ApiPaths } from '../../../api/APIPaths';
import { ICourse } from '../CoursesSlice';
import { ITrialClasses } from '.';

export type TCreateTrial = {
  curriculum: string;
  subject: string;
  grade: string;
  startDate: string;
  endDate: string;
  tutorId: string;
};

const apiDataProvider = new APIDataProvider();

export const createTrial = createAsyncThunk(
  '/trials/create',
  async (data: TCreateTrial) => {
    const path = `${ApiPaths.trials}`;
    const response = await apiDataProvider.post<TApiResponse<ICourse>>(
      path,
      data
    );

    return response.data;
  }
);

export const getTrials = createAsyncThunk('/trials/getTrials', async () => {
  const path = `${ApiPaths.trials}`;
  const response = await apiDataProvider.get<TApiResponse<ITrialClasses>>(path);

  return response.data;
});
